import $ from 'jquery';
window.$ = window.jQuery = $;
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

// make Masonry a jQuery plugin
jQueryBridget( 'masonry', Masonry, $ );
jQueryBridget( 'imagesLoaded', imagesLoaded, $ );

(function($, window, document) {
	"use strict";

	var TLS_Blog = function() {

        var self = this;

        this.masonry_init = function(){
            $('.grid').imagesLoaded( function() {
                $('.grid').masonry({
                    columnWidth: '.grid-sizer',
                    itemSelector: '.grid-item',
                    percentPosition: true,
                });
            });            
        };

        this.bind = function() {
            $( document ).ready( self.masonry_init );
        };
        
        this.init = function() {
			self.bind();
		};

		this.init();

	};

	( new TLS_Blog() );

}(window.jQuery, window, document));